import type { datadogRum } from "@datadog/browser-rum";
import { observeOsanoConsent } from "../osano";
import type { OsanoConsentObserver } from "../osano";

type TrackingConsent = Parameters<typeof datadogRum.setTrackingConsent>[0];
type ConsentSdk = Pick<typeof datadogRum, "setTrackingConsent">;

/**
 * The `trackingConsent` to pass to `init`. With a consent manager on the page
 * RUM must wait for the visitor's answer; without one (qa, stg, local) it
 * reports as before.
 */
export function initialTrackingConsent(
  consentManagerConfigured: boolean
): TrackingConsent {
  return consentManagerConfigured ? "not-granted" : "granted";
}

/**
 * Keeps the SDK's tracking consent equal to Osano's Analytics category, which
 * is where compliance classified RUM. Call after `init`; returns the observer
 * to disconnect on teardown.
 */
export function syncTrackingConsentWithOsano(
  sdk: ConsentSdk
): OsanoConsentObserver {
  return observeOsanoConsent("ANALYTICS", (granted) =>
    sdk.setTrackingConsent(granted ? "granted" : "not-granted")
  );
}
